// extracted by mini-css-extract-plugin
module.exports = {"entering":"animation-slideDown-module--entering--3_2xt","entered":"animation-slideDown-module--entered--1wv85","exiting":"animation-slideDown-module--exiting--eehl9"};